import { IRoute, ICrudRoute } from '@interfaces/App.interface';
import KPIOperationPage from '@pages/DataBase/Configuration/Kpis/KpiOperationPage';
import KPIPage from '@pages/DataBase/Configuration/Kpis/KPIsPage';
import KpiExecutionResults from '@pages/DataBase/Configuration/Kpis/KpiDefinitionExecutionResults';
import KPIMetrics from '@pages/DataBase/Configuration/Kpis/KpiMetrics';
import { generateCRUDRoutes } from './routes.utils';

//#region CRUD
const crudEntitiesData: ICrudRoute[] = [
  //KpiOperations
  {
    aclId: 'KpiOp',
    entityName: 'kpiOperation',
    DataTable: null,
    FormPage: KPIOperationPage,
  },
  //KPI
  { aclId: 'KpiDef', entityName: 'kpi', DataTable: null, FormPage: KPIPage },
];

//#region KPIs
const kpisRoutes: IRoute[] = [
  {
    id: 'kpiExecutionResults',
    matchPath: '/kpiExecutionResults/:kpiId/:executionId',
    pageComponent: KpiExecutionResults,
    pageTitle: 'Kpi execution results',
    aclId: 'KpiExRes',
  },
  {
    id: 'kpiResults',
    matchPath: '/kpiResults',
    pageComponent: KPIMetrics,
    pageTitle: 'KPI & metrics',
    aclId: 'KpiRepDef',
  },
  {
    id: 'itemsKpis',
    matchPath: '/itemsKpis',
    pageComponent: KPIMetrics,
    pageTitle: 'KPI & metrics',
    aclId: 'KpiRepDef',
  },
];
//#endregion

export default [...kpisRoutes, ...generateCRUDRoutes(crudEntitiesData)];
